package pwgs.ui.scenes.customstatscene

import kotlinx.browser.window
import pwgs.ui.components.BarChart
import pwgs.ui.components.BarChartItem
import pwgs.ui.components.BigStatNumber
import pwgs.ui.scenes.analyticsdashboardscene.AnalyticsDashboardSceneState
import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.core.Visage
import visage.dom.tag
import visage.ds.colorpalette.Skin
import visage.ds.components.Card
import visage.ds.components.page.Page

class MCustomStatScene(props: CustomStatSceneProps) : AScene<CustomStatSceneProps, CustomStatSceneModel, CustomStatSceneState, CustomStatControllerFe>(props) {

    private val statColors = listOf<String>(Skin.palette.infoColor, Skin.palette.successColor, Skin.palette.warningColor, Skin.palette.dangerColor)

    private fun getStatColor(index: Int): String {
        return statColors[index % statColors.size]
    }

    override fun createController() : CustomStatControllerFe {
        return CustomStatControllerFe(props, this)
    }

    override fun initState() : CustomStatSceneState {
        return CustomStatSceneState(null)
    }

    override fun onComponentDidMount() {
        super.onComponentDidMount()
        var timerId = window.setInterval({
            this@MCustomStatScene.controller.refreshTodayStat()
        }, 3000)
        this.state = CustomStatSceneState(timerId)

    }

    override fun onComponentDidUnmount() {
        super.onComponentDidUnmount()
        if (this.state.timerId != null) {
            window.clearInterval(this.state.timerId!!)
        }
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val model = this@MCustomStatScene.model

        var todayTotalCount = 0L;
        model.todayStat.values.forEach {
            todayTotalCount += it;
        }

        val allStatKeys = mutableSetOf<String>()

        model.todayStat.forEach {
            allStatKeys.add(it.key)
        }

        model.last30DayStat.forEach {
            allStatKeys.addAll(it.values.keys)
        }

        Page {
            head("Analytics > ${this@MCustomStatScene.props.statName}")

            body {
                Card {
                    header("Today")

                    body {
                        tag("div") {
                            style.apply {
                                display = "flex"
                                flexWrap = "wrap"
                                alignItems = "flex-end"
                                justifyContent = "center"
                                width = "100%"
                            }

                            tag("div") {
                                style.apply {
                                    display = "inline-block"
                                    width = "200px"
                                }

                                BigStatNumber("Total", this@MCustomStatScene.getStatValueStr(todayTotalCount) , Skin.palette.normalTextColor)
                            }

                            allStatKeys.forEachIndexed { index, it ->
                                val color = this@MCustomStatScene.getStatColor(index)
                                tag("div") {
                                    style.apply {
                                        display = "inline-block"
                                        width = "200px"
                                    }

                                    BigStatNumber(it, this@MCustomStatScene.getStatValueStr(model.todayStat[it] ?: 0) , color)
                                }
                            }
                        }
                    }
                }

                var maxValue = 0L
                var totalLast30Day = 0L
                model.last30DayStat.forEach {
                    var currentMaxVal = 0L
                    it.values.values.forEach { value ->
                        totalLast30Day += value
                        currentMaxVal += value
                    }
                    if (currentMaxVal > maxValue) {
                        maxValue = currentMaxVal
                    }
                }

                Card {
                    header("Total last 30 day: ${this@MCustomStatScene.getStatValueStr(totalLast30Day)}")

                    body {
                        BarChart(200, Skin.palette.normalTextColor, maxValue.toInt(), model.last30DayStat.map {
                            var dayTotal = 0L
                            it.values.values.forEach { value ->
                                dayTotal += value
                            }
                            BarChartItem("${it.date}: ${this@MCustomStatScene.getStatValueStr(dayTotal)}", dayTotal.toInt())
                        })
                    }
                }

                allStatKeys.forEachIndexed { index, statKey ->
                    var last30Total = 0L
                    model.last30DayStat.forEach {
                        last30Total += it.values[statKey] ?: 0L
                    }
                    Card {
                        header("${statKey} last 30 day: ${this@MCustomStatScene.getStatValueStr(last30Total)}")

                        body {
                            BarChart(200, this@MCustomStatScene.getStatColor(index), maxValue.toInt(), model.last30DayStat.map {
                                val value = it.values[statKey] ?: 0L
                                BarChartItem("${it.date}: ${this@MCustomStatScene.getStatValueStr(value)}", value.toInt())
                            })
                        }
                    }
                }

            }
        }
    }

    fun getStatValueStr(value: Long): String {
        var visibleValue = value;
        if (this.props.divider > 1) {
            visibleValue = visibleValue / this.props.divider
        }

        if (this.props.decimalDivider > 1) {
            val intPiece = visibleValue / this.props.decimalDivider
            val decPiece = visibleValue % this.props.decimalDivider
            var decDivStr = "${props.decimalDivider - 1}"
            var decPieceStr = "$decPiece"
            while (decPieceStr.length < decDivStr.length) {
                decPieceStr = "0" + decPieceStr
            }

            return "${this.props.prefix}${intPiece}${props.decimalSeparator}${decPieceStr}${this.props.postfix}"
        } else {
            return "${this.props.prefix}${visibleValue}${this.props.postfix}"
        }
    }
}

class CustomStatSceneState(val timerId: Int?) {

}

fun Components.CustomStatScene(props: CustomStatSceneProps) = this.registerComponent(MCustomStatScene(props), {})
